
import { mapGetters } from 'vuex'

import Logo from '../Logo'

export default {
  components: {
    Logo,
  },
  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),

    isRebrandingExperimentActive() {
      return this.experiments.headerSoftRebranding === 'white'
    },

    headerClassNames() {
      return [
        {
          'bg-black': !this.isRebrandingExperimentActive,
          'bg-secondary border-b border-neutral':
            this.isRebrandingExperimentActive,
        },
      ]
    },
  },
}
